module.exports = __webpack_public_path__ + "media/images/avatar_female2-e58285204a302e4fa63c8782c9754c3d.png";